
import { useQuery } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";
import { BaseResponse } from "../_types";
import { QueryKeys } from "../queryKeys";

interface IGetMerchantWithTcknRequest {
	tckn: string;
}

type IGetMerchantWithTcknResponse = BaseResponse<any>;

async function getMerchantWithTckn(tckn: string): Promise<IGetMerchantWithTcknResponse> {
  try {
    const response = await axiosInstance.get("/Todeb/SearchLiabilityInfoWithTCKN", {
      params: { tckn }
    });
    return response.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any)?.error;
  }
}export function useGetMerchantWithTckn(tckn?: string) {
	return useQuery<any | undefined, Error>(
		[QueryKeys.GetMerchantWithTckn, tckn],
		() => getMerchantWithTckn(tckn!),
		{ enabled: !!tckn }
	);
}
